angular.module('property-deal')
    .controller('PropertyDealFileAttachController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, PropertyDeal, PropertyDealService, FileUploaderCustom) {
        this.PropertyDealService = PropertyDealService;
        this.form = {
            id: data.id,
            stage: data.stage
        }

        this.$onInit = () => {
            this.uploader = FileUploaderCustom.create("/crm/api/property-deal/" + this.form.id + "/" + this.form.stage + "/attachment", this.formFn, this.close)
        }
        this.formFn = () => {
            return this.form
        }

        this.close = () => $uibModalInstance.close();
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
